<nav [style.background-position-y]="bgRandomPosition">
  <ul class="clearfix">
    <li><a routerLink="home"><img src="../../assets/img/me-logo.svg" alt="me logo"></a></li>
    <li><a routerLink="skills">{{'menu.skills'|translate}}</a></li>
    <li><a routerLink="experiences">{{'menu.exp'|translate}}</a></li>
    <li><a routerLink="trainings-and-diplomas">{{'menu.trainings'|translate}}</a></li>
    <li><a routerLink="culture">{{'menu.culture'|translate}}</a></li>
  </ul>
</nav>